import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const conversionRoutes: PermissionedRouteObject = {
  handle: {
    breadcrumb: "Conversion",
    breadcrumbNavigate: false,
    permission: [
      SettingsPermissions.SET_TNPL_SETTINGS,
      SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
    ],
  },
  path: "conversion",
  children: [
    {
      path: "custom-js",
      handle: {
        breadcrumb: "Custom JavaScript",
        permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
      },
      lazy: async () => {
        const { CustomJsSettingsPage } = await import(
          "./custom-js/custom-js-settings-page"
        );
        return { Component: CustomJsSettingsPage };
      },
    },
    {
      handle: {
        breadcrumb: "Try first",
        breadcrumbNavigate: false,
        permission: SettingsPermissions.SET_TNPL_SETTINGS,
      },
      path: "try-first",
      children: [
        {
          index: true,
          lazy: async () => {
            const { TryFirstPage } = await import("./try-first/try-first");
            return { Component: TryFirstPage };
          },
        },
        {
          handle: {
            breadcrumb: "Cart optimization",
            breadcrumbNavigate: false,
            permission: SettingsPermissions.SET_TNPL_SETTINGS,
          },
          path: "cart-optimization",
          lazy: async () => {
            const { CartOptimizationPage } = await import(
              "./cart-optimization/cart-optimization"
            );
            return { Component: CartOptimizationPage };
          },
        },
      ],
    },
    {
      path: "general",
      handle: {
        breadcrumb: "General",
        permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { ConversionGeneralSettingsPage } = await import(
              "./general/conversion-general-settings-page"
            );
            return { Component: ConversionGeneralSettingsPage };
          },
        },
      ],
    },
  ],
};
